import React from 'react';
import { usePageHeader } from '@/hooks/usePageHeader';
import { PageContainer } from '@/components/ui/PageContainer/PageContainer';
import { AttachmentsManager } from '@/components/Attachments/AttachmentsManager';
import { t } from '@/lib/i18n';

export function OrgAttachments() {
  usePageHeader({ title: t('Attachments'), breadcrumbs: [{ label: t('Organization'), path: '/organization' }] });

  return (
    <PageContainer>
      <div className="min-h-[500px]">
        <AttachmentsManager onClose={() => {}} embedded={true} />
      </div>
    </PageContainer>
  );
}


